import { Platform } from "react-native";
import { accountStore } from "./account-store";
import { authEvents } from "./auth-events";
import {
  clearTokens,
  decodeToken,
  invalidateIdentity,
  refreshTokens,
  saveRefreshToken,
  saveToken,
} from "./auth.api";

const isWeb = Platform.OS === "web";

export const MAX_REFRESH_ATTEMPTS = 2;

type TokenData = { access_token: string; refresh_token: string };

let refreshPromise: Promise<TokenData> | null = null;

const doRefresh = async (): Promise<TokenData> => {
  const activeAccount = await accountStore.getActive();
  const data = await refreshTokens();

  if (isWeb) {
    invalidateIdentity();
  } else {
    await saveToken(data.access_token);
    await saveRefreshToken(data.refresh_token);
    const decoded = await decodeToken();
    if (decoded?.user_id && activeAccount) {
      await accountStore.upsert({
        ...activeAccount,
        accessToken: data.access_token,
        refreshToken: data.refresh_token ?? activeAccount.refreshToken,
        role: decoded.roles ?? activeAccount.role,
        organization: decoded.org_id ?? activeAccount.organization,
      });
    }
  }

  return data;
};

export const coordinatedRefresh = (): Promise<TokenData> => {
  if (!refreshPromise) {
    refreshPromise = doRefresh().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
};

export const handleAuthFailure = async (): Promise<void> => {
  await clearTokens();
  authEvents.triggerLogout();
};
